import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUserProfile } from "common";

export type UserSliceType = IUserProfile & { token: string | undefined, expiration: number };

const initialState: UserSliceType = {
    id:          "",
    name:        "",
    family_name: "",
    email:       "",
    attrs:       {},
    token:       undefined,
    expiration:  0
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state: UserSliceType, action: PayloadAction<UserSliceType>) => {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.family_name = action.payload.family_name;
            state.email = action.payload.email;
            state.attrs = { ...action.payload.attrs };
            state.token = action.payload.token;
            state.expiration = action.payload.expiration;
        },
        logout: (state) => {
            state = initialState;
            
            localStorage.removeItem("token");
        }
    }
});

// Action creators are generated for each case reducer function
export const { login, logout } = authSlice.actions;

export default authSlice.reducer;